import React from 'react';

const Sample = () => (
  <h1>
    This is small React application
  </h1>
);

export default Sample;
